import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import cn from 'classnames';
import { CloseButton, GridItem, TextButton, TextField, useOverlayContext, WithInfoIcon } from 'seagull';
import IntroVideoModal from '~/components/AgreementStudioPage/AgreementStudioModal/IntroVideo/IntroVideoModal/IntroVideoModal';
import { isUrlValid } from '~/components/AgreementStudioPage/AgreementStudioModal/IntroVideo/IntroVideoModal/IntroVIdeoModal.utils';
import VideoPlayer from '~/components/VideoPlayer/VideoPlayer';
import { useLocaleKeys } from '~/i18n';
import { introVideoModel } from '~/models';
import { makeIntroVideoLink, makeIntroVideoNone } from '~/models/intro-video';
import styles from './IntroVideoField.module.scss';
const IntroVideoField = (param)=>{
    let { introVideo, onChange, className, disabled } = param;
    const { t: texts } = useLocaleKeys('components.agreementStudio.introVideo');
    const overlayContext = useOverlayContext();
    const [videoName, setVideoName] = useState('');
    const videoLink = introVideoModel.videoUrl(introVideo) || '';
    const onIntroVideoSave = (videoName, videoLink)=>{
        setVideoName(videoName);
        onChange(makeIntroVideoLink(videoLink.trim()));
    };
    const openIntroVideoModal = async ()=>{
        await overlayContext.showModal({
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (p)=>/*#__PURE__*/ _jsx(IntroVideoModal, _object_spread({
                    onSave: onIntroVideoSave,
                    videoLink: videoLink
                }, p))
        });
    };
    return /*#__PURE__*/ _jsxs(GridItem, {
        span: 12,
        className: cn(styles.firstRow, className),
        children: [
            /*#__PURE__*/ _jsxs(WithInfoIcon, {
                info: texts.infoText(),
                children: [
                    !videoName && /*#__PURE__*/ _jsx(TextButton, {
                        testId: "add-intro-video",
                        disabled: disabled,
                        underline: "none",
                        onClick: openIntroVideoModal,
                        children: "+ Add an introductory video"
                    }),
                    isUrlValid(videoLink) && !videoName && /*#__PURE__*/ _jsx("div", {
                        style: {
                            display: 'none'
                        },
                        children: /*#__PURE__*/ _jsx(VideoPlayer, {
                            url: videoLink,
                            onReady: (param)=>{
                                let { videoName } = param;
                                setVideoName(videoName);
                            }
                        })
                    }),
                    videoName && /*#__PURE__*/ _jsx(TextField, {
                        collapseHelperText: false,
                        mobile: {
                            renderAsCard: true
                        },
                        width: 512,
                        label: texts.fieldLabel(),
                        testId: "intro-video-name",
                        value: videoName,
                        disabled: disabled,
                        disableSuffixPadding: true,
                        suffix: !disabled && /*#__PURE__*/ _jsx(CloseButton, {
                            testId: "intro-video-remove-video-name-button",
                            skin: "transparent",
                            onClick: ()=>{
                                setVideoName('');
                                onChange(makeIntroVideoNone());
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(TextButton, {
                testId: "intro-video-preview",
                onClick: openIntroVideoModal,
                disabled: disabled,
                style: {
                    visibility: videoName ? 'visible' : 'hidden'
                },
                children: "Preview"
            })
        ]
    });
};
export default IntroVideoField;
